var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.5C6.125 19.5 3.5 18 2.0625 15.5C0.625 13.0312 0.625 10 2.0625 7.5C3.5 5.03125 6.125 3.5 9 3.5C11.8438 3.5 14.4688 5.03125 15.9062 7.5C17.3438 10 17.3438 13.0312 15.9062 15.5C14.4688 18 11.8438 19.5 9 19.5ZM12.5312 10.0312H12.5C12.8125 9.75 12.8125 9.28125 12.5 8.96875C12.2188 8.6875 11.75 8.6875 11.4688 8.96875L8 12.4688L6.53125 11C6.21875 10.6875 5.75 10.6875 5.46875 11C5.15625 11.2812 5.15625 11.75 5.46875 12.0312L7.46875 14.0312C7.75 14.3438 8.21875 14.3438 8.53125 14.0312L12.5312 10.0312Z",
    fill: "#B3D67B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleTick);
export default __webpack_public_path__ + "static/media/greenCircleTick.b65c41366971455d4c5842f94cffc4ca.svg";
export { ForwardRef as ReactComponent };